var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.75C7.25 4.12665 9.37665 2 12 2C14.6234 2 16.75 4.12665 16.75 6.75V9.31216C16.2859 8.96914 15.7833 8.67511 15.25 8.43772V6.75C15.25 4.95507 13.7949 3.5 12 3.5C10.2051 3.5 8.75 4.95507 8.75 6.75V8.43772C8.21668 8.67511 7.71414 8.96914 7.25 9.31216V6.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 10.1196C15.8077 10.4422 16.313 10.8452 16.75 11.3129C17.8356 12.4745 18.5 14.0347 18.5 15.75C18.5 19.3399 15.5899 22.25 12 22.25C8.41015 22.25 5.5 19.3399 5.5 15.75C5.5 14.0347 6.16445 12.4745 7.25 11.3129C7.68704 10.8452 8.19233 10.4422 8.75 10.1196C9.70606 9.56653 10.8161 9.25 12 9.25C13.1839 9.25 14.2939 9.56653 15.25 10.1196ZM11.375 15.4167C11.375 15.0485 11.7108 14.75 12.125 14.75C12.5392 14.75 12.875 15.0485 12.875 15.4167V17.2833C12.875 17.6515 12.5392 17.95 12.125 17.95C11.7108 17.95 11.375 17.6515 11.375 17.2833V15.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLock);
export default __webpack_public_path__ + "static/media/video-lock.f0f2246143564610fbed5a44fbd8cee9.svg";
export { ForwardRef as ReactComponent };